import LinkItemFormConfig from "./form";
import GenericForm from "../GenericForm";
import { LinkItemApi, LinkItemDataType } from "@/api/LinkItemApi";
import { LinkItemFormData } from "@/formTypes/LinkItemFormDataType";

type LinkItemFormProps = {
    id?: string;
    formId: string;
    saveRedirectUrl?: string;
    defaultData?: LinkItemDataType;
    onStored?: (data?: LinkItemDataType) => void;
};

const LinkItemForm = (props: LinkItemFormProps) => {
    const { id, formId, saveRedirectUrl, defaultData, onStored } = props;

    return (
        <GenericForm<LinkItemFormData, LinkItemDataType>
            id={id}
            formId={formId}
            saveRedirectUrl={saveRedirectUrl}
            defaultData={defaultData}
            onStored={onStored}
            formConfig={LinkItemFormConfig}
            getById={(...args) => LinkItemApi.get(...args)}
            createFn={(...args) => LinkItemApi.create(...args)}
            updateFn={(...args) => LinkItemApi.update(...args)}
            successMessage="El enlace ha sido almacenado correctamente"
            errorMessage="No fue posible almacenar el enlace"
        />
    );
};

export default LinkItemForm;
